// gatsby-browser.js
// Called when the Gatsby browser runtime first starts.
exports.onClientEntry = () => {
    if (!HTMLElement.prototype.scrollTo) {
        HTMLElement.prototype.scrollTo = function (left, top) {
            this.scrollTop = top
            this.scrollLeft = left
        }
    }
}